import { isBlankMap } from "__common/constants/map";
import { isGFT, isULA } from "__common/constants/products";
import { state } from "__common/store";
import { createDimensionBG } from "__editor/googleMapsRoofsSelector/models/advanceRoofSelecting";
import { topLeftCoordsByArray } from "./arrayNumberOrder";
import * as PIXI from "pixi.js";

// GFT, ULA, and Lite number arrays by draw order. Other classic products keep
// groupId order so existing projects render the same numbers as before.
const getPixelCoordsForTopLeftPanelOfArray = (): Array<{ x: number; y: number }> => {
  const { panels: { panels }, app, projectConfiguration: { productId } } = state();
  const orderByDrawnOrder = Boolean(app && app.isUbuilderLite) || isGFT(productId) || isULA(productId);
  return topLeftCoordsByArray(panels, orderByDrawnOrder);
};

export default function arrayNumberingModel(scale: number): PIXI.Graphics {
    const { roofsSelector: { mapType }, settings: { canvasCenter } } = state();
    const roofEdgeDimensions = new PIXI.Graphics();
    const coordsInPx = getPixelCoordsForTopLeftPanelOfArray();
    const baseFontSize = 14;

    const fontStyle = new PIXI.TextStyle({
      fontSize: baseFontSize,
      fontWeight: "500",
      fill: 0xffffff,
    });

    const isBlank = isBlankMap(mapType);
    const backgroundTint = isBlank ? 0x000000 : 0x0B5394;

    coordsInPx.forEach((coord, index) => {
      const numberText = new PIXI.Text(`${index + 1}`, fontStyle);
      numberText.anchor.set(0.5);
      numberText.scale.set(1 / scale);
      numberText.x = coord.x + canvasCenter.x;
      numberText.y = coord.y + canvasCenter.y - 5 / scale - scale / 2;
      numberText.zIndex = 99999;
      const numberBg = createDimensionBG(numberText);
      numberBg.width *= 1.5;
      numberBg.tint = backgroundTint;

      roofEdgeDimensions.addChild(numberBg, numberText);
    });
    roofEdgeDimensions.zIndex = 99999;
    return roofEdgeDimensions;
    }